<script setup lang="ts">
import flag1 from "@/assets/images/flag/icon-flag-en.svg";
import flag4 from "@/assets/images/flag/icon-flag-fr.svg";
import flagit from "@/assets/images/flag/icon-flag-it.svg";
import flag2 from "@/assets/images/flag/icon-flag-ro.svg";
import flag3 from "@/assets/images/flag/icon-flag-zh.svg";
import type { languageType } from "@/types/HeaderTypes";
import { useI18n } from "vue-i18n";
const languageDD: languageType[] = [
  { title: "Italiano", subtext: "IT", value: "it", avatar: flagit },
  /* { title: "English", subtext: "UK", value: "en", avatar: flag1 },
  { title: "français", subtext: "French", value: "fr", avatar: flag2 },
  { title: "عربي", subtext: "Arbic", value: "ro", avatar: flag3 },
  { title: "中国人", subtext: "Chinese", value: "zh", avatar: flag4 },*/
];
const { locale } = useI18n();
</script>
<template>
  <!-- ---------------------------------------------- -->
  <!-- language DD -->
  <!-- ---------------------------------------------- -->
  <v-menu open-on-hover open-on-click>
    <template v-slot:activator="{ props }">
      <v-btn
        icon
        class="custom-hover-primary"
        size="small"
        variant="text"
        color="primary"
        v-bind="props"
      >
        <v-avatar size="20">
          <img
            v-if="locale === 'it'"
            :src="flagit"
            :alt="locale"
            width="22"
            height="22"
            class="obj-cover"
          />
          <img
            v-if="locale === 'en'"
            :src="flag1"
            :alt="locale"
            width="22"
            height="22"
            class="obj-cover"
          />
          <img
            v-if="locale === 'fr'"
            :src="flag4"
            :alt="locale"
            width="22"
            height="22"
            class="obj-cover"
          />
          <img
            v-if="locale === 'ro'"
            :src="flag2"
            :alt="locale"
            width="22"
            height="22"
            class="obj-cover"
          />
          <img
            v-if="locale === 'zh'"
            :src="flag3"
            :alt="locale"
            width="22"
            height="22"
            class="obj-cover"
          />
        </v-avatar>
      </v-btn>
    </template>
    <v-sheet rounded="md" width="200" elevation="10">
      <v-list class="theme-list">
        <v-list-item
          v-for="(item, index) in languageDD"
          :key="index"
          color="primary"
          :active="locale == item.value"
          class="d-flex align-center"
          @click="() => (locale = item.value)"
        >
          <template v-slot:prepend>
            <v-avatar size="22">
              <img
                :src="item.avatar"
                :alt="item.avatar"
                width="22"
                height="22"
                class="obj-cover"
              />
            </v-avatar>
          </template>
          <v-list-item-title class="text-subtitle-1 font-weight-regular">
            {{ item.title }}
            <span class="text-disabled text-subtitle-1 pl-2">({{ item.subtext }})</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-menu>
</template>
